<template>
  <v-container
    id="about"
    tag="section"
  >
    <base-subheading><h1 class="text-center mt-5" style="font-family: 'Montserrat Subrayada', sans-serif;">ŻYWICZNE SYSTEMY POSADZKOWE</h1></base-subheading>
    <v-col cols="10" offset-md="1">

      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;">
        Jesteśmy wykonawcą żywicznych systemów posadzkowych. 
        Nasze posadzki to gwarancja jakości na najwyższym poziomie. 
        Stosujemy sprawdzone żywice syntetyczne do powłok posadzkowych niemieckiej firmy StoCretec. 
        Oferujemy analizę obiektu, dobór odpowiedniego systemu oraz profesjonalne prace wykonawcze.
      </p>
      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;">
        Ponad profesjonalne wykonanie posadzki żywicznej oferujemy doradztwo w zakresie wykonywania podłóg żywicznych oparte na wieloletnim doświadczeniu naszych pracowników. Prowadzimy sprzedaż żywic epoksydowych, poliuretanowych, metakrylowych oraz żywic alifatycznych. Pomagamy w zakresie wyboru odpowiedniego systemu żywicznego:
        <ul>
          <li>CIENKOPOWŁOKOWE systemy posadzkowe</li>
          <li>GRUBOPOWŁOKOWE systemy posadzkowe</li>
          <li>ELASTYCZNE i DEKORACYJNE systemy posadzkowe</li>
        </ul>
      </p>
      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;">
        Nasza firma posiada gotowe systemy posadzkowe sprawdzonego producenta żywic. Oferujemy pomoc w zakresie wyboru rodzaju systemu żywicznego na posadzkę oraz bezpłatną ofertę handlową. Wykonujemy pomiary parametrów podłoża na etapie realizacji oraz udzielamy gwarancji na wykonane usługi.
      </p>

      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;">
        <base-subheading><h4 class="text-center mt-5" style="font-family: 'Montserrat Subrayada', sans-serif;">POSADZKI PRZEMYSŁOWE, PARKINGI i GARAŻE, BALKONY i WNĘTRZA</h4></base-subheading>
      </p>
      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;">
        Żywica syntetyczna w porównaniu do betonu jest o wiele bardziej odporna na ściskanie i rozciąganie, dlatego też na etapie projektowania podłogi to podłoże betonowe powinno być dobrane pod wszystkie obciążenia dynamiczne, statyczne oraz termiczne. Jeżeli sama posadzka betonowa wytrzyma działające na nią czynniki, również ułożona na niej powłoka żywiczna nie ulegnie uszkodzeniu.
      </p>
      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;">
        Odpowiednio wykonana posadzka żywiczna ogranicza do minimum ryzyko poślizgu, które spada wraz ze wzrostem szorstkości posadzki. Trzeba jednak pamiętać, że im bardziej szorstkie podłoże tym trudniej utrzymać je w czystości. Właściwy wybór powłoki to konsens między bezpieczeństwem a wygodą eksploatacji.
      </p>
      <p class="text-justify" style="font-family: 'Montserrat', sans-serif;">
        Produkcja przemysłowa wymaga stosowania agresywnych substancji chemicznych. Żywiczne systemy posadzkowe są odporne na poszczególne czynniki chemiczne w różnym stopniu. Na etapie projektowania posadzki w tym przypadku należy zebrać jak najwięcej informacji odnośnie stosowanych substancji oraz czasu zalegania ich na podłodze. Następnie należy porównać je z kartami odporności chemicznej poszczególnych żywic posadzkowych. Żywice z których korzystamy dzielimy na trzy grupy obciążeń chemicznych. Szczegółowe informacje na ten temat udzieli nasz doradca.
      </p>

    </v-col>
    <hr>
  </v-container>
</template>

<script>
  export default {
    name: 'HomeAbout',
  }
</script>
